import { render, staticRenderFns } from "./fsBlockProfit.vue?vue&type=template&id=0ea60ee5&scoped=true"
import script from "./fsBlockProfit.vue?vue&type=script&lang=js"
export * from "./fsBlockProfit.vue?vue&type=script&lang=js"
import style0 from "./fsBlockProfit.vue?vue&type=style&index=0&id=0ea60ee5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea60ee5",
  null
  
)

export default component.exports